import React from 'react';
import SEO from '../components/seo';
import SpotlightComponentList from '../components/SpotlightComponentList.jsx';

const Spotlight = ({ pageContext, location }) => {
  const { seo = {}, post = {} } = pageContext;

  const metaTitle =
    `Spotlight: ${post.title} | Eugenie Detroit` || 'Eugenie Detroit';
  const openGraphTitle =
    `Spotlight: ${post.title} | Eugenie Detroit` || 'Eugenie Detroit';
  const twitterTitle =
    `Spotlight: ${post.title} | Eugenie Detroit` || 'Eugenie Detroit';

  return (
    <React.Fragment>
      <SEO
        metaTitle={metaTitle}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={seo?.openGraphImage}
        twitterTitle={twitterTitle}
        twitterDescription={seo?.twitterDescription}
        twitterImage={seo?.twitterImage}
        pathname={location.pathname}
      />
      <section className="spotlight__header df x fdc fdr--md bb--dark-brown">
        <aside className="spotlight__header-title p2 pt5--md ">
          <div className="title df mb2 aib">
            <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
              Spotlight
            </p>
            <p className="serif--sm serif--lg--lg">{post.title}</p>
          </div>
          <div className="desc df aib">
            <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
              Dates
            </p>
            <p className="sans--sm sans--md--lg">{post.dates}</p>
          </div>
        </aside>
        <aside className="spotlight__header-image">
          <div className="spotlight__header-image-wrapper">
            {post.heroImage && (
              <picture className="">
                <source
                  srcSet={`${post.heroImage.url}?w=2000&auto=format&q=100`}
                  media="(min-width: 1800px)"
                />
                <source
                  srcSet={`${post.heroImage.url}?w=1800&auto=format&q=100`}
                  media="(min-width: 1400px)"
                />
                <source
                  srcSet={`${post.heroImage.url}?w=1400&auto=format&q=100`}
                  media="(min-width: 1000px)"
                />
                <source
                  srcSet={`${post.heroImage.url}?w=1000&auto=format&q=100`}
                  media="(min-width: 800px)"
                />
                <source
                  srcSet={`${post.heroImage.url}?w=800&auto=format`}
                  media="(min-width: 600px)"
                />
                <img
                  alt={post.title}
                  className="x db"
                  src={`${post.heroImage.url}?w=600&auto=format`}
                />
              </picture>
            )}
          </div>
        </aside>
      </section>
      <section className="spotlight__body pt2 pt5--md pb2 pb5--md">
        <SpotlightComponentList components={post.body} />
      </section>
    </React.Fragment>
  );
};

export default Spotlight;
